module.exports = __webpack_public_path__ + "static/img/2设计师2.61bccb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/2设计师2.png
// module id = HoY/
// module chunks = 1